import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Span = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLSpanElement>
  ) => {
    return (
      <span
        ref={ref}
        className={cn(
          'text-inherit font-inherit leading-inherit tracking-inherit',
          className
        )}>
        {children}
      </span>
    )
  }
)

Span.displayName = 'Span'

export default Span
